import { Injectable } from "@angular/core";
import { CoreLogService } from "./log.service";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { ApiResponse, YourAppServerApi } from "./YourAppServer/YourAppServerApi.service";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { AddressVerifyRequest, AddressVerifyResponse } from "../shared/models/addressVerify.model";

export class Address {
    public street: string;
    public streetNumber: string;
    public postalCode: string;
    public city: string;
}

@Injectable({ providedIn: "root" })
export class AddressVerificationService {
    private readonly endpoint = "address/verify";

    constructor(
        private _coreLogService: CoreLogService,
        private _objObsInjectHelper: CircularInjectionHelper,
    ) { }

    public async verify(address: Address): Promise<AddressVerifyResponse> {
        try {
            const response = await this.sendRequest(address);

            if (response.OK) {
                this._coreLogService.debug("AddressVerificationService.verify", "RequestService (response OK)", response);
                return response.Data;
            } else {
                this._coreLogService.error("AddressVerificationService.verify", "RequestService (response not OK)", response);
                throw new Error(response.HttpResponse.codeText);
            }
        } catch (error) {
            this._coreLogService.error("AddressVerificationService", "verify", error);
            throw error;
        }
    }

    private async sendRequest(address: Address): Promise<ApiResponse<AddressVerifyResponse>> {
        return this._objObsInjectHelper.yourAppServer.Api.RequestService(
            AddressVerifyResponse,
            this.endpoint,
            this.toVerifyRequest(address)
        );
    }

    private toVerifyRequest(address: Address): AddressVerifyRequest {
        return {
            Street: address.street,
            StreetNumber: address.streetNumber,
            PostalCode: address.postalCode,
            City: address.city,
        };
    }
}